/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-08-01_gamma-radiation.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-08-01_gamma-radiation.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-08-01_gamma-radiation.mdx';

const metadata = {
  slug: "2020-08-01_gamma-radiation",
  title: "Woo-Woo (wuwu)",
  author: "Christian Battaglia",
  description: "I don't believe in astrology. I do believe in woo-woo — the name I give the gaps after the map runs out. A Sturgeon Moon, a blood moon, gamma rays, a sensitive brain, and the idea that everything left over after science is God.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-08-01",
  edits: [{"date":"2026-09-11","note":"Retitled around woo-woo and expanded the argument."}],
  readTime: "8 min read",
  tags: ["astrophysics","gamma radiation","full moon","Sturgeon Moon","science","philosophy","woo-woo","neurology"],
};

export const Route = createFileRoute('/blog/posts/2020-08-01_gamma-radiation')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-08-01_gamma-radiation',
    image: '/og/blog/2020-08-01_gamma-radiation.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: "2026-09-11",
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
